
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"color",attrs:{"cx":"19","cy":"19","r":"19","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M21.034 12.614a.4.4 0 00-.67.295V15a.5.5 0 01-.5.5H12.6a.6.6 0 00-.6.6v5.8a.6.6 0 00.6.6h7.264a.5.5 0 01.5.5v2.09a.4.4 0 00.67.296l6.604-6.054a.45.45 0 000-.664l-6.604-6.054z","fill":"#EDEDED"}})])
          )
        }
      }
    